import { ReactElement, Suspense, useEffect } from 'react';
import { Loader } from 'team-hero-ui';

import Routes from 'routes';
import { useCurrentUser } from 'hooks/useCurrentUser';
import GlobalComponentsProvider from 'components/GlobalComponentsProvider';
import CompatibilityGate from 'components/CompatibilityGate';

const App = (): ReactElement => {
  const user = useCurrentUser();

  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (window as any).userEmail = user.email || '';
  }, [user.email]);

  return (
    <>
      <CompatibilityGate>
        <Suspense fallback={<Loader loaderType='fixed' loaderSize='big' />}>
          <Routes />
        </Suspense>
      </CompatibilityGate>
      <GlobalComponentsProvider />
    </>
  );
};

export default App;
